import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { Logo } from '@/components/Logo';

export function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
      <Logo showText={false} className="mb-6 scale-150" />
      <p className="text-sm font-semibold text-accent-blue">404</p>
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-text-primary">Page not found</h1>
      <p className="mt-2 max-w-sm text-text-secondary">
        The page you’re looking for doesn’t exist or may have moved.
      </p>
      <Link to="/" className="mt-6">
        <Button>Back to home</Button>
      </Link>
    </div>
  );
}
